import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux'
import { CancelOrderReschudle, GetAllOrdersAdmin } from '../../redux/actions/OrdersAdmin';
import { DeleteBackage, GetAllBaqa } from '../../redux/actions/BaqaAction';
import { MdDelete } from "react-icons/md";

const DeleteBaqa = ({ idData }) => {

    const [showEdit, setShowEdit] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = () => setShowEdit(true);
    const dispatch = useDispatch();

    const cancelOrder = async () => {
        try {
            setLoading(false);
            await dispatch(DeleteBackage({
                id: idData
            }))
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(true);
            handleCloseEdit();
            dispatch(GetAllBaqa())
        }
    }
    return (
        <div>
            {/* <button onClick={handleShowEdit} style={{ color: "#EB5757", background: "#EB575733" }} className='btn'>إلغاء الطلب</button> */}
            <MdDelete onClick={handleShowEdit} size={"20"} color='#EB5757' />
            <Modal show={showEdit} onHide={handleCloseEdit} className='font' centered>
                <Modal.Header>
                    <Modal.Title>حذف الباقه</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h2>هل تريد حذف  الباقه</h2>
                </Modal.Body>
                <Modal.Footer className='m-auto w-100'>

                    <button className='btn' onClick={cancelOrder} style={{ width: "45%", background: "#FECB44", color: "black" }}>
                        تاكيد الحذف
                    </button>
                    <button className='btn' onClick={handleCloseEdit} style={{ width: "45%", background: "#FFFAEC", color: "black", border: "1px solid #FECB44" }}>
                        تراجع
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DeleteBaqa
